import { getDeviceInfo } from "helpers/utils";
import api from "../api";

export async function FetchCityList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/location/city-list`,
  });
}

export async function FetchCityById(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/location/city-list/get/${id}`,
  });
}

export async function DeleteCityRecord(id) {
  return await api({
    method: "delete",
    url: `${process.env.REACT_APP_API_URL}/admin/location/delete-city/${id}`,
  });
}

export async function FetchAreaList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/location/area-list`,
  });
}

export async function FetchAreaById(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/location/area-list/get/${id}`,
  });
}

export async function FetchRegionList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/location/region-list`,
  });
}

export async function FetchRegionById(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/location/region-list/get/${id}`,
  });
}

export async function FetchStateList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/location/state-list`,
  });
}

export async function FetchStateById(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/location/state-list/get/${id}`,
  });
}

export async function FetchLocationList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/location/location-list`,
  });
}

export async function DeleteAreaRecord(id) {
  return await api({
    method: "delete",
    url: `${process.env.REACT_APP_API_URL}/admin/location/delete-area/${id}`,
  });
}

export async function DeleteRegionRecord(id) {
  return await api({
    method: "delete",
    url: `${process.env.REACT_APP_API_URL}/admin/location/delete-region/${id}`,
  });
}

export async function DeleteStateRecord(id) {
  return await api({
    method: "delete",
    url: `${process.env.REACT_APP_API_URL}/admin/location/delete-state/${id}`,
  });
}

export async function updatestatus(appl_id, status, comment, status_change_from) {
  let authUser = JSON.parse(localStorage.getItem("authUser"));
  let user_id = authUser.user.id;
  let device_info = await getDeviceInfo(navigator);
  return await api({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/admin/common/update-status/${appl_id}`,
    data: { status, comment, user_id, status_change_from, device_info },
  });
}

export async function CreateRegionRecord(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/location/create-region`,
  });
}

export async function UpdateRegionRecord(data, id) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/location/edit-region/${id}`,
  });
}

export async function CreateAreaRecord(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/location/create-area/`,
  });
}

export async function UpdateAreaRecord(data, id) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/location/edit-area/${id}`,
  });
}

export async function CreateStateRecord(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/location/create-state/`,
  });
}

export async function UpdateStateRecord(data, id) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/location/edit-state/${id}`,
  });
}

export async function CreateCityRecord(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/location/create-city/`,
  });
}

export async function UpdateCityRecord(data, id) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/location/edit-city/${id}`,
  });
}
